<template>
  <div>
    <select-field label="选择处理函数" v-model="type" :list="funcList" :disabled="!editable"></select-field>
    <fields v-model="args" :fields="funcFields" :disabled="!editable"></fields>
    <submit-field @click="submit" :disabled="!editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
  import SelectField from '@/components/utils/select-field'
  import Fields from '@/components/utils/fields'
  import SubmitField from '@/components/utils/submit-field'

  export default {
    props: {
      defaults: {
        required: false,
        default: Object.create(null),
        type: Object
      },
      event: {
        required: false,
        default: 'func',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    data () {
      return {
        type: '',
        args: {}
      }
    },
    components: {
      SelectField,
      Fields,
      SubmitField
    },
    computed: {
      funcConfig () {
        return this.$store.state.Config.func
      },
      funcList () {
        let list = []

        for (let [key, val] of Object.entries(this.funcConfig)) {
          list.push({
            key: val.name,
            value: key
          })
        }

        return list
      },
      funcFields () {
        let fields = []
        let info = this.funcConfig[this.type]
        if (!info) {
          return []
        }

        for (let index in info.fields) {
          let field = info.fields[index]

          let obj = {
            name: index.toString(),
            field: this.mapTypeToField(field.type),
            props: {
              label: field.label
            }
          }

          if (field.type === 'select') {
            obj.props.list = field.options
          }

          fields.push(obj)
        }

        return fields
      },
      isValid () {
//        return this.type && this.funcFields.every(field => !!this.args[field.name])
        return true
      }
    },
    methods: {
      mapTypeToField (type) {
        const map = {
          number: 'input-field',
          string: 'input-field',
          select: 'select-field'
        }

        return map[type]
      },
      submit () {
        this.$emitter.emit(this.event, {
          _id: this.defaults._id,
          type: this.type,
          args: Array.prototype.slice.call(Object.assign(this.args, {
            length: this.funcFields.length
          }))
        })

        this.$emitter.once(`${this.event}Resp`, err => {
          if (!err) {
            this.editable = false
          }
        })
      },
      refresh () {
        this.type = this.defaults.type
        for (let [index, value] of Object.entries(this.defaults.args)) {
          this.$set(this.args, index, value)
        }
      }
    },
    watch: {
      defaults () {
        this.refresh()
      },
      type () {
        if (this.defaults.type === this.type) {
          this.refresh()
        } else {
          Object.keys(this.args).forEach(key => this.$delete(this.args, key))
        }
      }
    },
    created () {
      this.refresh()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/func.vue